module.exports = __webpack_public_path__ + "img/2.c6368f6d.jpg";